import React from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import CrmButton from './CrmButton';
import './crm-ui.scss';

export function CrmSkeleton({ lines = 3, className = '' }) {
  return (
    <div className={`crm-skeleton ${className}`.trim()} aria-hidden="true">
      {Array.from({ length: lines }, (_, index) => (
        <span key={index} style={{ width: index === lines - 1 ? '64%' : '100%' }} />
      ))}
    </div>
  );
}

export function CrmLoadingState({ message = 'Loading…', minHeight = 180 }) {
  return (
    <div className="crm-feedback-state" style={{ minHeight }} role="status" aria-live="polite">
      <div className="crm-feedback-state__skeleton">
        <CrmSkeleton lines={3} />
      </div>
      <span className="crm-feedback-state__message">{message}</span>
    </div>
  );
}

export function CrmErrorState({
  title = 'Something went wrong',
  message,
  retryLabel = 'Try again',
  onRetry,
}) {
  return (
    <div className="crm-feedback-state" role="alert">
      <ErrorOutlineIcon className="crm-feedback-state__icon crm-feedback-state__icon--error" />
      <h3>{title}</h3>
      {message ? <p>{message}</p> : null}
      {onRetry ? <CrmButton variant="secondary" onClick={onRetry}>{retryLabel}</CrmButton> : null}
    </div>
  );
}

export function CrmEmptyState({
  icon,
  title = 'Nothing here yet',
  message,
  actionLabel,
  onAction,
}) {
  return (
    <div className="crm-feedback-state">
      {icon || <InboxOutlinedIcon className="crm-feedback-state__icon" />}
      <h3>{title}</h3>
      {message ? <p>{message}</p> : null}
      {actionLabel && onAction ? (
        <CrmButton variant="secondary" onClick={onAction}>{actionLabel}</CrmButton>
      ) : null}
    </div>
  );
}
